import { useState, useEffect } from 'react'

export type CountdownFormat = 'mm:ss' | 'hh:mm:ss'

export interface RegenCountdownProps {
  seconds: number
  format?: CountdownFormat
  onComplete?: () => void
  className?: string
}

function formatTime(totalSeconds: number, format: CountdownFormat): string {
  const s = Math.max(0, totalSeconds)
  const mm = Math.floor(s / 60)
  const ss = s % 60
  const pad2 = (n: number) => String(n).padStart(2, '0')

  if (format === 'hh:mm:ss') {
    const hh = Math.floor(mm / 60)
    const remainMm = mm % 60
    return `${pad2(hh)}:${pad2(remainMm)}:${pad2(ss)}`
  }

  return `${pad2(mm)}:${pad2(ss)}`
}

export function RegenCountdown({
  seconds,
  format = 'mm:ss',
  onComplete,
  className,
}: RegenCountdownProps) {
  const [remaining, setRemaining] = useState(() => Math.max(0, seconds))

  useEffect(() => {
    setRemaining(Math.max(0, seconds))
  }, [seconds])

  useEffect(() => {
    if (remaining <= 0) {
      onComplete?.()
      return
    }

    const id = setTimeout(() => {
      setRemaining((prev) => {
        const next = prev - 1
        if (next <= 0) {
          onComplete?.()
          return 0
        }
        return next
      })
    }, 1000)

    return () => clearTimeout(id)
  }, [remaining, onComplete])

  return (
    <span
      className={className}
      style={{ fontVariantNumeric: 'tabular-nums' }}
    >
      {formatTime(remaining, format)}
    </span>
  )
}
